import { mediaByID, mediaCreate, mediaDestroy, mediaUpdate, mediasList } from '@/services/agency/showcaseMedias.service'

export default {
	namespaced: true,
	state: {
		// SHOWCASES MEDIAS
		mediasList: {
			data: [],
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		media: {},
		// STATUS SHOWCASES MEDIAS
		mediasStatus: 'pending',
		mediasSaveStatus: 'init',
		mediasDeleteStatus: 'init',
	},
	getters: {
		// SHOWCASES MEDIAS
		getMediasList(state) {
			return state.mediasList
		},
		getMedia(state) {
			return state.media
		},
		// SHOWCASES MEDIAS
		getMediasDeleteStatus(state) {
			return state.mediasDeleteStatus
		},
		getMediasSaveStatus(state) {
			return state.mediasSaveStatus
		},
		getMediasStatus(state) {
			return state.mediasStatus
		},
	},
	mutations: {
		// SHOWCASES MEDIAS
		MEDIAS_LIST(state, value) {
			state.mediasList = value
		},
		SET_MEDIA(state, value) {
			state.media = value
		},
		// STATUS SHOWCASES MEDIAS
		MEDIAS_STATUS(state, value) {
			state.mediasStatus = value
		},
		MEDIA_SAVE_STATUS(state, value) {
			state.mediasSaveStatus = value
		},
		MEDIA_DELETE_STATUS(state, value) {
			state.mediasDeleteStatus = value
		},
	},
	actions: {
		// SHOWCASES Medias
		async fetchMediaList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('MEDIAS_STATUS', 'pending')
			commit('MEDIAS_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const merged = { per_page: 'all', ...params }
				const { data } = await mediasList(merged)
				commit('MEDIAS_STATUS', 'init')
				commit('MEDIAS_LIST', data)
				return data
			} catch (error) {
				commit('MEDIAS_STATUS', 'init')
				throw error
			}
		},
		async fetchMediaByID({ commit }, params) {
			commit('MEDIAS_STATUS', 'pending')
			try {
				const { data } = await mediaByID(params)
				commit('MEDIAS_STATUS', 'init')
				commit('SET_MEDIA', data.data)
				return data
			} catch (error) {
				commit('MEDIAS_STATUS', 'init')

				return error
			}
		},
		async saveNewMedia({ commit }, params) {
			commit('MEDIA_SAVE_STATUS', 'pending')
			try {
				const { data } = await mediaCreate(params)
				commit('MEDIA_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MEDIA_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateMedia({ commit }, params) {
			commit('MEDIA_SAVE_STATUS', 'pending')
			try {
				const { data } = await mediaUpdate(params)
				commit('MEDIA_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MEDIA_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteMediaByID({ commit }, params) {
			commit('MEDIA_DELETE_STATUS', 'pending')
			try {
				const { data } = await mediaDestroy(params)
				commit('MEDIA_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MEDIA_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
